import SectionValidate from "./components/sectionValidate";

function LandingPageOneValidate() {
  return (
    <div id="landingPageOneValidate">
      <SectionValidate />
    </div>
  );
}

export default LandingPageOneValidate;
